import React, { useState, useEffect } from 'react';

const CONDITION_OPTIONS = [
  { value: 'QUY_TRINH', label: 'Giải quyết theo quy trình mất hồ sơ gốc' },
  { value: 'BAN_CHINH', label: 'Chứng từ nguồn gốc là bản chính hoặc bản sao có công chứng' },
  { value: 'BAN_PHO_TO', label: 'Chứng từ nguồn gốc là bản phô tô' },
  { value: 'KHAC', label: 'KHÁC (nhập nội dung)' }
];

const DOCUMENT_STATUS_OPTIONS = [
  { value: 'hop_le', label: 'Hợp lệ' },
  { value: 'khong_hop_le', label: 'Không hợp lệ' }
];

const defaultForm = {
  licensePlate: '',
  registrationDate: '',
  ownerName: '',
  ownerAddress: '',
  vehicleType: '',
  brand: '',
  engineNumber: '',
  chassisNumber: '',
  manufactureYear: '',
  documentStatus: '',
  condition: '',
  conditionDetail: '',
  unitId: ''
};

const SpecialMotoForm = ({ initialData, onSave, onCancel, user, units }) => {
  const [formData, setFormData] = useState(defaultForm);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (initialData) {
      setFormData({
        licensePlate: initialData.licensePlate || '',
        registrationDate: initialData.registrationDate
          ? initialData.registrationDate.substring(0, 10)
          : '',
        ownerName: initialData.ownerName || '',
        ownerAddress: initialData.ownerAddress || '',
        vehicleType: initialData.vehicleType || '',
        brand: initialData.brand || '',
        engineNumber: initialData.engineNumber || '',
        chassisNumber: initialData.chassisNumber || '',
        manufactureYear: initialData.manufactureYear || '',
        documentStatus: initialData.documentStatus || '',
        condition: initialData.condition || '',
        conditionDetail: initialData.conditionDetail || '',
        unitId: initialData.unitId || ''
      });
    } else {
      setFormData({
        ...defaultForm,
        unitId: user && user.role !== 'admin' && user.role !== 'supervisor' ? (user.unitId || '') : ''
      });
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (name === 'condition' && value !== 'KHAC') {
      setFormData(prev => ({ ...prev, [name]: value, conditionDetail: '' }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!formData.licensePlate.trim()) {
      setError('Vui lòng nhập biển số xe.');
      return;
    }
    setSubmitting(true);
    try {
      await onSave(formData);
    } catch (err) {
      setError(err.message || 'Có lỗi xảy ra');
    } finally {
      setSubmitting(false);
    }
  };

  const isAdmin = user && user.role === 'admin';

  const inputStyle = {
    width: '100%',
    padding: '8px 12px',
    borderRadius: '8px',
    border: '1.5px solid #c5cae9',
    fontSize: '14px',
    outline: 'none',
    boxSizing: 'border-box',
    transition: 'border 0.2s',
    fontFamily: 'inherit'
  };

  const labelStyle = {
    display: 'block',
    fontWeight: '600',
    fontSize: '13px',
    color: '#37474f',
    marginBottom: '5px'
  };

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '14px'
  };

  const fullWidthStyle = { gridColumn: '1 / -1' };

  return (
    <form onSubmit={handleSubmit}>
      {error && (
        <div style={{
          background: '#ffebee', color: '#b71c1c', borderRadius: '8px',
          padding: '10px 14px', marginBottom: '16px', fontSize: '14px'
        }}>
          {error}
        </div>
      )}

      <div style={gridStyle}>

        {/* Biển số */}
        <div>
          <label style={labelStyle}>Biển số <span style={{ color: '#c62828' }}>*</span></label>
          <input
            style={inputStyle}
            name="licensePlate"
            value={formData.licensePlate}
            onChange={handleChange}
            placeholder="VD: 86-B1 23456"
            required
          />
        </div>

        {/* Ngày đăng ký */}
        <div>
          <label style={labelStyle}>Ngày đăng ký</label>
          <input
            type="date"
            style={inputStyle}
            name="registrationDate"
            value={formData.registrationDate}
            onChange={handleChange}
          />
        </div>

        {/* Tên chủ phương tiện */}
        <div style={fullWidthStyle}>
          <label style={labelStyle}>Tên chủ phương tiện</label>
          <input
            style={inputStyle}
            name="ownerName"
            value={formData.ownerName}
            onChange={handleChange}
            placeholder="Họ và tên chủ xe"
          />
        </div>

        {/* Địa chỉ */}
        <div style={fullWidthStyle}>
          <label style={labelStyle}>Địa chỉ</label>
          <textarea
            style={{ ...inputStyle, resize: 'vertical', minHeight: '60px' }}
            name="ownerAddress"
            value={formData.ownerAddress}
            onChange={handleChange}
            placeholder="Địa chỉ thường trú"
          />
        </div>

        {/* Loại xe máy chuyên dùng */}
        <div style={fullWidthStyle}>
          <label style={labelStyle}>Loại xe máy chuyên dùng</label>
          <input
            style={inputStyle}
            name="vehicleType"
            value={formData.vehicleType}
            onChange={handleChange}
            placeholder="VD: Xe cẩu, xe lu, xe xúc..."
          />
        </div>

        {/* Nhãn hiệu */}
        <div>
          <label style={labelStyle}>Nhãn hiệu (Mác/Kiểu)</label>
          <input
            style={inputStyle}
            name="brand"
            value={formData.brand}
            onChange={handleChange}
            placeholder="VD: Komatsu PC200"
          />
        </div>

        {/* Năm sản xuất */}
        <div>
          <label style={labelStyle}>Năm sản xuất</label>
          <input
            type="number"
            style={inputStyle}
            name="manufactureYear"
            value={formData.manufactureYear}
            onChange={handleChange}
            placeholder="VD: 2020"
            min="1900"
            max={new Date().getFullYear() + 1}
          />
        </div>

        {/* Số động cơ */}
        <div>
          <label style={labelStyle}>Số động cơ</label>
          <input
            style={inputStyle}
            name="engineNumber"
            value={formData.engineNumber}
            onChange={handleChange}
            placeholder="Số động cơ"
          />
        </div>

        {/* Số khung */}
        <div>
          <label style={labelStyle}>Số khung</label>
          <input
            style={inputStyle}
            name="chassisNumber"
            value={formData.chassisNumber}
            onChange={handleChange}
            placeholder="Số khung (VIN)"
          />
        </div>

        {/* Loại hồ sơ */}
        <div>
          <label style={labelStyle}>Loại hồ sơ</label>
          <select
            style={inputStyle}
            name="documentStatus"
            value={formData.documentStatus}
            onChange={handleChange}
          >
            <option value="">-- Chọn loại hồ sơ --</option>
            {DOCUMENT_STATUS_OPTIONS.map(opt => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
        </div>

        {/* Tình trạng */}
        <div style={fullWidthStyle}>
          <label style={labelStyle}>Tình trạng</label>
          <select
            style={inputStyle}
            name="condition"
            value={formData.condition}
            onChange={handleChange}
          >
            <option value="">-- Chọn tình trạng --</option>
            {CONDITION_OPTIONS.map(opt => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
          {formData.condition === 'KHAC' && (
            <textarea
              style={{ ...inputStyle, marginTop: '8px', resize: 'vertical', minHeight: '70px' }}
              name="conditionDetail"
              value={formData.conditionDetail}
              onChange={handleChange}
              placeholder="Nhập nội dung tình trạng khác..."
            />
          )}
        </div>

        {/* Đơn vị (chỉ admin chọn được) */}
        {isAdmin && units && units.length > 0 && (
          <div style={fullWidthStyle}>
            <label style={labelStyle}>Đơn vị</label>
            <select
              style={inputStyle}
              name="unitId"
              value={formData.unitId}
              onChange={handleChange}
            >
              <option value="">-- Chọn đơn vị --</option>
              {units.map(u => (
                <option key={u.id} value={u.id}>{u.name}</option>
              ))}
            </select>
          </div>
        )}
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '22px' }}>
        <button type="button" className="sm-btn sm-btn-secondary" onClick={onCancel}>
          Hủy
        </button>
        <button type="submit" className="sm-btn sm-btn-primary" disabled={submitting}>
          {submitting ? 'Đang lưu...' : (initialData ? 'Cập nhật' : 'Thêm mới')}
        </button>
      </div>
    </form>
  );
};

export default SpecialMotoForm;
